<template>
  <div class="tw-fixed tw-inset-0 tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-infinity-background-faded-modal tw-backdrop-filter tw-backdrop-blur">
    <base-infinity-loading class="tw-w-24" />
  </div>
</template>
<script>
import BaseInfinityLoading from "../base/base-infinity-loading";
export default {
  components: { BaseInfinityLoading }
};
</script>
